export const environment = {
  production: true,
  api: '/api',
};
